import { L, vocabulary } from '../define.js';
/** Exemplar domain catalog (D577): every vocabulary typed against the domain's own code list. */
export const RIDE_VOCABULARIES = [
    vocabulary('ride.status', '@vello/ride RIDE_STATUSES', {
        requested: L('Solicitada', 'Requested', 'Solicitado', 'Richiesta'),
        searching: L('Procurando motorista', 'Finding a driver', 'Buscando conductor', 'Ricerca autista'),
        assigned: L('Motorista a caminho', 'Driver assigned', 'Conductor asignado', 'Autista assegnato'),
        en_route: L('A caminho do embarque', 'On the way to pickup', 'En camino a la recogida', 'In arrivo al ritiro'),
        arrived: L('Motorista no local', 'Driver arrived', 'Conductor en el lugar', 'Autista arrivato'),
        in_progress: L('Em andamento', 'In progress', 'En curso', 'In corso'),
        completed: L('Concluída', 'Completed', 'Completado', 'Completata'),
        cancelled: L('Cancelada', 'Cancelled', 'Cancelado', 'Annullata'),
        no_driver: L('Sem motorista', 'No driver found', 'Sin conductor', 'Nessun autista'),
    }),
];
//# sourceMappingURL=ride.js.map